import { ACCOUNT_FACADES } from './account';
import { CustomerService } from './customer';
import { GENERAL_FACADES } from './general';
import { GENERAL_GUARDS } from './guards';
import { NEWS_FACADES } from './news';
import { SupportFacade } from './support';
import { TicketsFacade } from './tickets';
import { ConsumptionComparisonService, ConsumptionFacade } from './consumption';
import { SharedContentFacade } from './shared-content';
import {
  EmailSettingsFacade,
  NotificationSettingsFacade,
  NotificationsFacade,
} from './notifications';
import { HomepageModuleFacade } from './homepage-module';
import { PaymentRequestsFacade } from './payment';
import { ResidentFeedbackFacade } from './feedback';

export * from './account';
export * from './general';
export * from './interceptors';
export * from './news';
export * from './tickets';
export * from './support';
export * from './guards';
export * from './consumption';
export * from './resolvers';
export * from './shared-content';
export * from './file';
export * from './validators';
export * from './notifications';
export * from './newrelic';
export * from './customer';
export * from './homepage-module';
export * from './payment';
export * from './logging';
export * from './error-handler';
export * from './consent';
export * from './feedback';

export const FACADES = [
  ...GENERAL_FACADES,
  ...ACCOUNT_FACADES,
  ...NEWS_FACADES,
  TicketsFacade,
  SupportFacade,
  ConsumptionFacade,
  SharedContentFacade,
  NotificationsFacade,
  HomepageModuleFacade,
  PaymentRequestsFacade,
  NotificationSettingsFacade,
  EmailSettingsFacade,
  ResidentFeedbackFacade,
];
export const GUARDS = [...GENERAL_GUARDS];
// StoreReviewService is deliberately absent: it is `providedIn: 'root'`. Anything
// listed here is re-provided inside every lazy module that imports SharedModule,
// which would shadow the platform override registered at the root.
export const SERVICES = [CustomerService, ConsumptionComparisonService];
